/**
 * Visibility Settings Component
 * Allows users to control what battles and pack openings they see
 */

Vue.component('visibility-settings', {
  template: templates.visibilitySettings,
  data() {
    return {
      model: {
        battleVisibility: 'all',
        packVisibility: 'all',
        isPanelOpen: false,
        showSaveConfirmation: false
      }
    };
  },
  created() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      const c = this;
      visibilityService.getSettings()
        .then(function (response) {
          c.model.battleVisibility = response.data.battleVisibility;
          c.model.packVisibility = response.data.packVisibility;
        })
        .catch(function () {
          // Use defaults if error
          c.model.battleVisibility = 'all';
          c.model.packVisibility = 'all';
        });
    },
    togglePanel() {
      this.model.isPanelOpen = !this.model.isPanelOpen;
    },
    saveSettings() {
      const c = this;

      let data = {
        battleVisibility: c.model.battleVisibility,
        packVisibility: c.model.packVisibility
      };

      visibilityService.saveSettings(data)
        .then(function () {
          c.$root.$emit('visibilityChanged', 'both');
          utils.alert.success('Settings saved!');
        })
        .catch(function () {
          utils.alert.error('Failed to save settings!');
        });
    },
    resetSettings() {
      const c = this;

      if (confirm('Reset all visibility settings to defaults?')) {
        visibilityService.resetSettings()
          .then(function () {
            c.loadSettings();
            c.$root.$emit('visibilityChanged', 'both');
            utils.alert.success('Settings reset to defaults!');
          })
          .catch(function () {
            utils.alert.error('Failed to reset settings!');
          });
      }
    },
    formatMode(mode) {
      const modes = {
        'all': 'All',
        'own': 'Only Mine',
        'none': 'Hidden'
      };
      return modes[mode] || mode;
    }
  }
});
